import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_collection_view_tabs = _resolveComponent("ontos-collection-view-tabs")!
  const _component_ontos_kanban_board = _resolveComponent("ontos-kanban-board")!
  const _component_ontos_view_instance_dialog = _resolveComponent("ontos-view-instance-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_ontos_kanban_board, {
      ref: "board",
      key: `${_ctx.context.system}/${_ctx.context.idea}`,
      context: _ctx.context,
      workspace: _ctx.workspace,
      onOpenInstance: _ctx.onOpenInstance,
      onNoDimensions: _ctx.goToList,
      onShowMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMessage', $event))),
      onShowErrorMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
    }, _createSlots({ _: 2 }, [
      (_ctx.$vuetify.display.xs)
        ? {
            name: "tabs",
            fn: _withCtx(() => [
              _createVNode(_component_ontos_collection_view_tabs, {
                idea: _ctx.idea,
                ideas: _ctx.workspace.ideas
              }, null, 8, ["idea", "ideas"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["context", "workspace", "onOpenInstance", "onNoDimensions"])),
    (_ctx.instanceOnView)
      ? (_openBlock(), _createBlock(_component_ontos_view_instance_dialog, {
          key: 0,
          context: _ctx.instanceOnView,
          preview: _ctx.previewOnView,
          workspace: _ctx.workspace,
          onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.board.refreshInstance($event))),
          onDeleted: _cache[3] || (_cache[3] = ($event: any) => (_ctx.board.removeInstance($event))),
          onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.instanceOnView = null)),
          onShowMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, null, 8, ["context", "preview", "workspace"]))
      : _createCommentVNode("", true)
  ]))
}